<template>
  <div class="page-wrapper" :style="width ? { width } : {}">
    <span v-if="countPage > 0" class="pre-page" @click="changeCountPage('pre')">上一页</span>
    <template v-for="i in pageNum">
      <span v-if="countPage * size < i && i <= (countPage + 1) * size" :key="i" class="page-number"
        :class="i === page ? 'is-activity' : ''" @click="selectPage(i)">{{ i }}</span>
      <!-- next page -->
    </template>
    <span v-if="(countPage + 1) * size < pageNum" class="next-page" @click="changeCountPage('next')">下一页</span>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: ['currentPage', 'pageSize', 'total', 'width'],
  computed: {
    //当前页
    page: function () {
      return this.currentPage || 1
    },
    // 每页的条数
    size: function () {
      return this.pageSize || 10
    },
    // 总共的页数
    pageNum: function () {
      if (this.total) {
        return Math.ceil(this.total / this.size)
      } else {
        return this.page
      }
    }
  },
  data() {
    return {
      countPage: 0, // 下一页计数
    }
  },
  methods: {
    selectPage(page) {
      page !== this.page && this.$emit('pageChange', page)
    },
    changeCountPage(op) {
      if (op === 'next') {
        this.countPage += 1
        let activitypage = this.countPage * this.size + 1
        this.$emit('pageChange', activitypage)
      } else if (op === 'pre') {
        this.countPage -= 1
        let activitypage = this.countPage * this.size + 1
        this.$emit('pageChange', activitypage)
      }
    }
  }
}
</script>

<style scoped>
.page-wrapper {
  padding-top: 10px;
  padding-bottom: 10px;
  width: 80rem;
  margin: 0 auto;
  text-align: center;
}

.page-number {
  display: inline-block;
  background-color: #ffffff;
  font-size: 12px;
  color: #f77549;
  /* padding: 1.2rem 2rem; */
  width: 3.6rem;
  height: 3.6rem;
  text-align: center;
  line-height: 3.6rem;
  margin-right: 1.5rem;
  border-radius: 6px;
  cursor: pointer;
}

.page-number:hover {
  color: #ffffff;
  background-color: #f77549;
}

.is-activity {
  color: #ffffff;
  background-color: #f77549;
}

.pre-page {
  margin-right: 1.5rem;
}

.pre-page,
.next-page {
  background-color: #ffffff;
  font-size: 12px;
  color: #f77549;
  display: inline-block;
  height: 3.6rem;
  line-height: 3.6rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  border-radius: 6px;
  cursor: pointer;
}
</style>